<h1
	mat-dialog-title
	class="dialog-title m-0 fw-bold fs-4 pb-3a"
>
	{{ "sellerSelector.title" | translate }}
</h1>
<div
	mat-dialog-content
	style="min-height: 150px"
>
	<mat-chip-listbox>
		@for (element of data.sellers; track element) {
			<mat-chip-option (click)="selectRole(element)">{{ element.name + " " + element.surname }}</mat-chip-option>
		}
	</mat-chip-listbox>
</div>
<div
	class="justify-content-center"
	mat-dialog-actions
>
	<button
		class="text-center"
		mat-button
		(click)="onClose(null)"
	>
		{{ "sellerSelector.close" | translate }}
	</button>
</div>